'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Validator = require('./Validator');

var _Validator2 = _interopRequireDefault(_Validator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Validator2.default; /**
                                        * export default component
                                        */
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/validate-framework-utils/lib/index.js
// module id = 6
// module chunks = 0